import { COMPANY_PROJECT_TYPES_ENUM } from '@woovi/roles';
import { queryString } from '@woovi/shared';

import { PLUGIN_TYPE } from '../PluginType.ts';

const { parse } = queryString;

export const defaultOrderNodeOpenPix = 'openpix-order';
export const defaultOrderNodeWoovi = 'woovi-order';
export const defaultNodeWooviButton = 'woovi-pay';
export const defaultClickPixAttribute = 'clickpix';

export const getAttribute = (node: Element, attr: string): string | null => {
  if (node.hasAttribute(attr)) {
    return node.getAttribute(attr);
  }

  return null;
};

type ReturnHostNodes = {
  hostNodes: NodeListOf<any>;
  node: string;
  projectType: string;
  pluginType: string;
};
const getHostNodes = (): ReturnHostNodes => {
  const openpixHostNodes = document.querySelectorAll(
    `#${defaultOrderNodeOpenPix}`,
  );

  if (openpixHostNodes.length !== 0) {
    return {
      hostNodes: openpixHostNodes,
      node: defaultOrderNodeOpenPix,
      projectType: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
      pluginType: PLUGIN_TYPE.ORDER,
    };
  }

  const wooviHostNodes = document.querySelectorAll(`#${defaultOrderNodeWoovi}`);

  if (wooviHostNodes.length !== 0) {
    return {
      hostNodes: wooviHostNodes,
      node: defaultOrderNodeWoovi,
      projectType: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
      pluginType: PLUGIN_TYPE.ORDER,
    };
  }

  const wooviHostNodesButton = document.querySelectorAll(
    `[data-${defaultClickPixAttribute}]`,
  );

  return {
    hostNodes: wooviHostNodesButton,
    node: defaultNodeWooviButton,
    projectType: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
    pluginType: PLUGIN_TYPE.BUTTON,
  };
};

export type ScriptParams = {
  appID: string;
  correlationID: string;
  paymentLinkID: string;
  node: string;
  pluginType: string;
  isTemp: boolean;
  customerData: string;
  buttonVariant: string;
};

// <div id='woovi-button' data-appid={config.OPEN_PIX_APP_ID} />
// <div id='openpix-order' data-appid={config.OPEN_PIX_APP_ID} data-correlationid={correlationID} />
export const getParamsFromNode = (): ScriptParams => {
  const { hostNodes, node, pluginType } = getHostNodes();

  if (hostNodes.length === 0) {
    return {};
  }

  const [hostNode] = hostNodes;

  return {
    appID: getAttribute(hostNode, 'data-appid'),
    correlationID: getAttribute(hostNode, 'data-correlationID'),
    paymentLinkID: getAttribute(hostNode, 'data-paymentLinkID'),
    node,
    pluginType,
  };
};

export const getScriptParams = (): ScriptParams => {
  try {
    const me = document.currentScript;

    if (!me) {
      return getParamsFromNode();
    }

    const [, query] = me.src.split('?');

    if (!query) {
      return getParamsFromNode();
    }

    return parse(query);
  } catch (err) {
    return {};
  }
};
